import { AppLayout, PageHeader } from "@/components/Layout";
import { Sparkles, Route, Music, Gavel, MapPin, Ticket } from "lucide-react";

const CLASSES = [
  { icon: Sparkles, title: "Handling & Conditioning", desc: "Judges evaluate ground manners, conditioning, and the trust built between horse and trainer." },
  { icon: Route, title: "Trail", desc: "Horse and trainer navigate a course of natural and man-made obstacles." },
  { icon: Music, title: "Freestyle", desc: "A choreographed performance showcasing each team's unique partnership." },
];

export default function About() {
  return (
    <AppLayout>
      <PageHeader subtitle="Bluegrass Mustang Makeover" title="About the Event" />
      <div className="space-y-4 px-4 pt-2">
        <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
          <p className="text-base leading-relaxed text-foreground/85">
            Trainers from across the country have just <span className="font-semibold text-primary">120 days</span> to
            transform formerly wild mustangs into willing, confident partners. Teams compete in Handling &
            Conditioning, Trail, and Freestyle before many of the trained mustangs are offered in a live public auction.
          </p>
        </div>

        <div>
          <h2 className="mb-2 font-display text-xl font-bold text-primary">The Competition Classes</h2>
          <div className="space-y-2">
            {CLASSES.map(({ icon: Icon, title, desc }) => (
              <div key={title} className="flex items-start gap-3 rounded-xl border border-border bg-card p-4 shadow-sm">
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-primary/10 text-primary"><Icon size={20} /></span>
                <div><p className="font-semibold text-primary">{title}</p>
                  <p className="text-sm text-muted-foreground">{desc}</p></div>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-xl border border-secondary/40 bg-secondary/5 p-4">
          <div className="flex items-center gap-2">
            <Gavel size={18} className="text-secondary" />
            <h2 className="font-display text-lg font-bold text-primary">The Live Auction</h2>
          </div>
          <p className="mt-1 text-sm leading-relaxed text-foreground/80">
            After the competition, many trained mustangs are offered in a live public auction. Details on lots,
            terms, and how to participate will appear in the auction catalog closer to the event.
          </p>
        </div>

        <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
          <h2 className="font-display text-lg font-bold text-primary">Event Details</h2>
          <p className="mt-2 flex items-center gap-2 text-sm text-foreground/80"><Ticket size={15} className="text-secondary" /> Free admission both days</p>
          <p className="mt-1 flex items-start gap-2 text-sm text-foreground/80"><MapPin size={15} className="mt-0.5 shrink-0 text-secondary" /> Henry County Fairgrounds, 1106 Castle Highway, Eminence, KY 40019</p>
        </div>
      </div>
    </AppLayout>
  );
}
